export default __webpack_public_path__ + "static/media/all_accessories.5d753e79.jpeg";